import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { PanelLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  toggleCollectionsRail,
  useIsCollectionsRailCollapsed,
} from '@/features/knowledge-bases/model/collections-rail.store';

/** Shows and hides the collections rail beside the pane. */
export function CollectionsRailToggle() {
  const { t } = useTranslation('knowledge');
  const isCollapsed = useIsCollectionsRailCollapsed();

  // The button carries only a glyph, so the label it answers to is also the
  // only thing that says what it does. It is the same string in both places
  // rather than two wordings for one control.
  const label = isCollapsed
    ? t('knowledgeBases.collectionsRailToggle.showCollections')
    : t('knowledgeBases.collectionsRailToggle.hideCollections');

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon-lg"
            onClick={toggleCollectionsRail}
            aria-pressed={!isCollapsed}
            aria-label={label}
            data-testid="collections-rail-toggle"
          >
            <PanelLeftIcon className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

CollectionsRailToggle.displayName = 'CollectionsRailToggle';
